import React, { useEffect, useId, useState } from 'react';
import { signStorage } from '@battleops/client/src/session/session';
import { CREST_D, CREST_W, CREST_H } from '../lib/crest';

const BORDER = 22;
const PAD = BORDER / 2 + 2;
const VB = [-PAD, -PAD, CREST_W + PAD * 2, CREST_H + PAD * 2];

// The BattleBooks crest (the phone's CrestAvatar): your photo or initials inside the shield, gold border. Same traced
// path and box — never change the ratio.
export default function Crest({ width = 40, uri, initials = '?', border = 'var(--c-gold)' }) {
  const clip = `crest${useId().replace(/:/g, '')}`;
  return (
    <svg width={width} height={Math.round((width * VB[3]) / VB[2])} viewBox={VB.join(' ')} role="img" aria-label="Profile" style={{ flex: 'none', display: 'block' }}>
      <defs><clipPath id={clip}><path d={CREST_D} /></clipPath></defs>
      <g clipPath={`url(#${clip})`}>
        <rect x={VB[0]} y={VB[1]} width={VB[2]} height={VB[3]} fill="var(--c-surface-alt)" />
        {uri ? <image href={uri} x={VB[0]} y={VB[1]} width={VB[2]} height={VB[3]} preserveAspectRatio="xMidYMid slice" />
          : <text x={CREST_W / 2} y={CREST_H * 0.56} textAnchor="middle" fontSize="250" fontWeight="800" fontFamily="var(--font)" fill="var(--c-text-secondary)">{initials}</text>}
      </g>
      <path d={CREST_D} fill="none" stroke={border} strokeWidth={BORDER} strokeLinejoin="round" />
    </svg>
  );
}

// The BattleBooks profile photo (users/{uid}.avatarPath): a signed read URL, once per path per page load.
const memo = new Map();
export function useAvatarUri(path) {
  const [uri, setUri] = useState(() => (path ? memo.get(path) || null : null));
  useEffect(() => {
    if (!path) { setUri(null); return undefined; }
    if (memo.has(path)) { setUri(memo.get(path)); return undefined; }
    let alive = true;
    signStorage(path, 'read').then((url) => { if (url) { memo.set(path, url); if (alive) setUri(url); } }).catch(() => { /* offline — initials */ });
    return () => { alive = false; };
  }, [path]);
  return uri;
}
